<template>
  <div class="client-section">
    <div class="client-section__item">
      <div>
        Dipercaya oleh <span>1.000+ klien</span>
      </div>
    </div>

    <div class="client-section__wrapper">
      <div class="client-section__logo client-section__logo--top">
        <div
          v-for="(item, index) in client.slice(0, 4)"
          :key="index"
          class="client-section__logo__img"
        >
          <img
            :src="require(`@/assets/new-home/${item.img}`)"
            :alt="item.logo"
          >
        </div>
      </div>

      <div class="client-section__logo client-section__logo--bottom">
        <div
          v-for="(item, index) in client.slice(4)"
          :key="index"
          class="client-section__logo__img"
        >
          <img
            :src="require(`@/assets/new-home/${item.img}`)"
            :alt="item.logo"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Data from "../../app/constants/index";

export default {
  name: "ClientSection",
  data() {
    return {
      Data,
      client: [],
    }
  },
  async created() {
    this.client = this.Data.CLIENT
  },
}
</script>
    
<style lang="scss" scoped>
@import "style";
</style>
